const {
  removeClass,
  addClass,
  getElementsFromSelector,
} = require('../../shared/frontend/dom-helpers');

function addRemoveClasses(tab1, tab2) {
  getElementsFromSelector(`.${tab1}-content, .${tab1}-tab`).map(innerElement =>
    removeClass(innerElement, 'active')
  );

  getElementsFromSelector(`.${tab1}-tab`).map(innerElement => {
    removeClass(innerElement, 'c-bdr-prim');
    addClass(innerElement, 'c-bdr-gray-clr');
  });

  getElementsFromSelector(`.${tab2}-content, .${tab2}-tab`).map(innerElement =>
    addClass(innerElement, 'active')
  );

  getElementsFromSelector(`.${tab2}-tab`).map(innerElement => {
    addClass(innerElement, 'c-bdr-prim');
    removeClass(innerElement, 'c-bdr-gray-clr');
  });
}

function loginTab() {
  addRemoveClasses('signup', 'login');
}

function signupTab() {
  addRemoveClasses('login', 'signup');
}

module.exports = {
  init: () => {
    getElementsFromSelector('.login-tab').map(element => {
      element.onclick = loginTab;
    });

    getElementsFromSelector('.signup-tab').map(element => {
      element.onclick = signupTab;
    });
  },
};
